import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { classNames } from "@/utils/classNames";

import { Webhook } from "../../schema/webhook";
import { describeWebhookSigning } from "../../utils/describeWebhookSigning";

/** The Signing column (PREC-4249): whether deliveries are signed and the secret's state. */
export const WebhookSigningCell: FunctionComponent<{ webhook: Webhook }> = ({ webhook }) => {
	const { t } = useTranslation();
	const signing = describeWebhookSigning(webhook.signing);

	if (!signing) {
		return null;
	}

	return (
		<div className="flex flex-col items-start gap-1" data-test="webhook-signing">
			<span
				className={classNames(
					"rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
					signing.state === "signed"
						? "bg-status-success-light text-status-success"
						: "bg-status-warning-light text-text"
				)}
			>
				{t(`webhookSigning.state.${signing.state}`)}
			</span>
			{signing.lines.map((line) => (
				<span key={line.key} className="text-xs text-text-meta" data-test="webhook-signing-line">
					{t(line.key, line.params)}
				</span>
			))}
		</div>
	);
};
